import { Outlet } from "react-router-dom";
import logo from "../../../images/branding/logo-brown-text-white-inline.svg";
import { ExceptionMessage } from "../../../components";


export function CalendarLayout() {
  return(
    <div id="main-wrapper" className="position-fixed d-flex flex-column w-100 h-100">
      {/* Top Navbar */}
      <div id="main-topbar" className="position-relative flex-shrink-0">
        <nav className="navbar navbar-expand-lg bg-primary py-2 px-3 justify-content-center">
          <span className="py-2 lh-5 fs-3 me-0 ms-3">
            <img className="d-block" src={logo} width={176} alt="Ameena logo" />
          </span>
        </nav>
      </div>

      {/* Content Area */}
      <div className="d-flex flex-column flex-grow-1 overflow-hidden" style={{ minHeight: 0 }}>
        <div className="container-fluid py-4 flex-grow-1 d-flex flex-column" style={{ minHeight: 0 }}>
          {/* Optional error message */}
          <div className="d-flex justify-content-center">
            <ExceptionMessage />
          </div>
          <div className="flex-grow-1 overflow-hidden" style={{ minHeight: 0 }}>
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  )
}

export default CalendarLayout;
